import React, { useState } from "react";
import { newsletter } from "../data/siteData";
import { CheckCircle } from "lucide-react";

const NewsletterForm = () => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [subscribed, setSubscribed] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!/\S+@\S+\.\S+/.test(email)) {
      setError("Please enter a valid email");
      return;
    }
    setError("");
    const subs = JSON.parse(localStorage.getItem("p3_newsletter_subs") || "[]");
    subs.push({ email, subscribedAt: new Date().toISOString() });
    localStorage.setItem("p3_newsletter_subs", JSON.stringify(subs));
    setSubscribed(true);
  };

  if (subscribed) {
    return (
      <div className="flex items-center gap-2 text-sm text-p3-navy font-medium">
        <CheckCircle size={18} className="text-p3-blue" /> You're subscribed!
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-3 w-full max-w-md">
      <div className="flex-1">
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder={newsletter.placeholder}
          className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:outline-none focus:ring-2 focus:ring-p3-blue/40 text-sm"
        />
        {error && <p className="text-xs text-red-500 mt-1">{error}</p>}
      </div>
      <button
        type="submit"
        className="bg-p3-gold hover:bg-p3-gold/90 text-p3-navy font-semibold px-6 py-3 rounded-lg transition-colors whitespace-nowrap"
      >
        {newsletter.button}
      </button>
    </form>
  );
};

export default NewsletterForm;
